import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { CommonService } from '../../../api';
import { SnackService } from '../../../services';


@Component({
  selector: 'eagle-a2z-contract-lists',
  templateUrl: './a2z-contract-lists.component.html',
  styleUrls: ['./a2z-contract-lists.component.scss']
})
export class A2zContractListsComponent implements OnInit {

  @Input() Page_Size: any;
  @Input() PageSize_Options: any;
  @Input() HospitalGroupIconPath: string;
  @Input() editicon: string;
  @Input() deleteicon: string;
  @Input() userType: string;

  isCreateContract = false;
  isListContract = true;


  @ViewChild(MatPaginator)
  paginator: MatPaginator;
  @ViewChild(MatSort)
  sort: MatSort;

  filterdata: string;
  orderby: string;
  direction: string;

  Page_Index: number;
  totalLength: number;
  last_page: number;
  FormStatus: boolean = true;
  schoolInfo: any;
  user_id: number;


  from_date: any;
  fromdate: any;
  todate: any;

  paginatorIndex : any;

  contract_displayedColumns: string[];

  contractdataSource = new MatTableDataSource;

  constructor(
    private _userService: CommonService,
    private _SnackService: SnackService) { }

  ngOnInit(): void {

    if(this.userType == 'providerGroup'){
      this.contract_displayedColumns = [
        "id",
        "name",
        "contract_details",
        "hospital_group",
        // "provider",
        "hospital",
        "status"
        // "actions"
      ];

    }else{
      this.contract_displayedColumns = [
        "id",
        "name",
        "contract_details",
        // "hospital_group",
        "provider",
        // "hospital",
        "status"
        // "actions"
      ];

    }

    this.paginatorIndex ={
      pageIndex: 0,
      pageSize: this.Page_Size,
      filterValue: "",
      active: "name",
      direction: "asc"
    };
  }

  exp_Accordion(value): void {

    if (value && !this.isCreateContract) {
      this.getContractList(this.paginatorIndex);
    }
  }



  applyFilter(keyvalue: string,from: Date, to: Date) {

    this._SnackService.openSnackBar("Info","Filtering....");

    this.fromdate = from;
    this.todate = to;

    const filterValue = keyvalue;
    this.paginatorIndex.filterValue = filterValue ? filterValue.trim().toLowerCase() : '';

    this.getContractList(this.paginatorIndex);
    this.paginator.firstPage();

  }


  showContractlist() {
    this.isCreateContract = false;
    this.isListContract = true;
    this.getContractList(this.paginatorIndex);

    this.FormStatus = true;
  }

  showcreateContract(actionType,UserId) {
    this.isCreateContract = true;
    this.isListContract = false;

    if(actionType == "update"){
      this.FormStatus = false;
      this.user_id = UserId;
    }
    else{
      this.FormStatus = true;
      this.user_id = UserId;
    }
  }

  getContractList(event): void {

    event.fromdate = this.fromdate ? this.fromdate : "";
    event.todate = this.todate ? this.todate : "";
    event.active = this.orderby ? this.orderby : "updated_at";
    event.direction = this.direction ? this.direction : "desc";
    event.type = 'a2zContract';

    this.Page_Index = event.pageIndex + 1;
    this._userService.getContractList(event).subscribe(
        result => {
            this.contractdataSource = new MatTableDataSource(result.body.data.contracts);
            this.totalLength = result.body.data.pagination.total;
            this.Page_Size = result.body.data.pagination.per_page;
            this.last_page = result.body.data.pagination.last_page;
            var Pageoptions = new Array();
            for (let i = 1; i <= this.last_page; i++) {
                Pageoptions.push(result.body.data.pagination.per_page * i);
            }
            this.PageSize_Options = Pageoptions;

        }, error => {
            console.log(error);
        });

}

}
